import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataAccessAuthModule } from '@coach-bot/data-access/auth';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { SharedUIModule } from '@shared/ui';
import { ForgotPasswordComponent, SignInComponent } from './components';

const COMPONENTS = [ForgotPasswordComponent, SignInComponent];

@NgModule({
  imports: [
    ButtonsModule,
    DataAccessAuthModule,
    FormsModule,
    InputsModule,
    LabelModule,
    LoaderModule,
    NotificationModule,
    ReactiveFormsModule,
    SharedUIModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class AuthModule {}
